import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import OtpModal from "../../components/OtpPage";
import PostByAgg from "../../utils/axios";
import { useAuth } from "../../context/AuthContext";
import LottieLoading from "../../components/child/LottieLoading";
import ModalAlert from "../../components/ModalAlert";
import Cookies from "js-cookie"

const LoginPage = () => {
    // const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [apiMessage, setApiMessage] = useState('');
    const { email, setEmail,handleLoginSuccess, setRoleCode, setIsLoggedIn, setRoleName} = useAuth()
    const [isLoading, setIsLoading] = useState(false);
    const [modal,setOpenModal] = useState(<div></div>)


    const navigate = useNavigate();

    const handleEmailChange = (e) => {
      setEmail(e.target.value.toLowerCase());
    };

    const handleEmailPaste = (e) => {
      e.preventDefault();
      const text = e.clipboardData.getData('text');
      setEmail(text.toLowerCase());
    };


  //   const handleSubmit = (event) => {
  //     event.preventDefault();
  //     setIsLoading(true);

  //     const url = 'user/um/v1/login';
  //     const body = { email :email.trim().toLowerCase(), password };

  //     PostByAgg({
  //         url,
  //         body,
  //         onResponse: onResponseUser,
  //         onError: onErrorUser
  //     });

  //     function onResponseUser(response) {
  //       console.log("response login", response)
  //       if (response.data.code === "2002000") {   
  //         setApiMessage(response.data.message.id);
          
  //         // setShowOtpModal(true);
  //         navigate('/dashboard');
  //         setIsLoading(false) 
  //          // Simpan data ke cookies
  //         Cookies.set("email", email);
  //         Cookies.set("roleCode", roleCode);
  //         Cookies.set("roleName", roleName);
  //         Cookies.set("isLoggedIn", true);
  
  //         // Simpan data ke AuthContext
  //         setRoleCode(roleCode);
  //         setRoleName(roleName);
  //         setIsLoggedIn(true);
  //       } else {
  //         setError("Email atau password salah.");
  //       }
  //     }

  //     function onErrorUser(error) {
  //       setError(error.response.data.message.id);
  //       if(error.response.data.code){
  //         setIsLoading(false);
  //         setOpenModal(
  //           <ModalAlert
  //               show={true}
  //               type={'failed'}
  //               text={error.response.data.message.id}
  //               action={() => {}}
  //             />
  //         )
  //       }
  //     }
  // };

  const handleSubmit = (event) => {
      event.preventDefault();
      setIsLoading(true);
      performLoginValidations();
  };

  const performLoginValidations = () => {
      const url = 'user/um/v1/login-custom';
      const body = { email :email.trim().toLowerCase(), password , fcm_token: "abcdkjkdjf"};

      PostByAgg({
          url,
          body,
          onResponse: onResponseUser,
          onError: onErrorUser
      });

      function onResponseUser(response) {
        console.log("response login", response)
        if (response.data.code === "2002000") {   
          setApiMessage(response.data.message.id);
          const roleCode = response.data.data.role_code;
          const roleName = response.data.data.role_name;
          // setShowOtpModal(true);
          setIsLoading(false) 
          // LANGKAH 1: Hapus semua "ghost cookie" lama di semua kemungkinan path
          // Ini mengatasi bug duplikat cookie yang tersangkut di path berbeda
          const cookieNames = ["email", "roleCode", "roleName", "isLoggedIn", "musicLabelCode", "musicLabelName"];
          const paths = ["/", "/login", "/dashboard"];
          cookieNames.forEach(name => {
            paths.forEach(p => {
              document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=" + p;
            });
          });
          
          // LANGKAH 2: Simpan cookie BARU dengan masa aktif 7 hari
          Cookies.set("email", email, { expires: 7, path: '/' });
          Cookies.set("roleCode", roleCode, { expires: 7, path: '/' });
          Cookies.set("roleName", roleName, { expires: 7, path: '/' });
          Cookies.set("isLoggedIn", "true", { expires: 7, path: '/' });
          
          console.log("✅ Cookie persistent (7 hari) berhasil ditanam!");
          console.log("document.cookie:", document.cookie);
          
          // Simpan data ke AuthContext
          setRoleCode(roleCode);
          setRoleName(roleName);
          setIsLoggedIn(true);
          navigate('/dashboard');
        } else {
          setIsLoading(false);
          setError("Email atau password salah.");
        }
      }

      function onErrorUser(error) {
        const errorMessage = error.response?.data?.message?.id || "Terjadi kesalahan pada server.";
        const errorCode = error.response?.data?.code || null;
        
        // Auto-Kick Logic: Cek jika error menyatakan "Anda telah login"
        if (errorMessage.toLowerCase().includes("anda telah login") || errorMessage.toLowerCase().includes("telah login")) {
            // Lakukan Logout secara paksa untuk mencabut sesi lama, lalu panggil login ulang
            forceKickAndRelogin();
        } else {
            setError(errorMessage);
            if(errorCode){
                setIsLoading(false);
                setOpenModal(
                    <ModalAlert
                        show={true}
                        type={'failed'}
                        text={errorMessage}
                        action={() => { setOpenModal(<div></div>) }}
                    />
                )
            } else {
                setIsLoading(false);
            }
        }
      }
  };

  const forceKickAndRelogin = () => {
      PostByAgg({
          url: 'user/um/v1/logout',
          body: { email: email.trim().toLowerCase() },
          onResponse: (response) => {
              // Jika berhasil mati, coba login ulang secara instan
              performLoginValidations();
          },
          onError: (error) => {
              setIsLoading(false);
              setError("Gagal merefresh sesi lama. Silakan coba login kembali.");
          }
      });
  };

    return (
        <section className='auth bg-base d-flex flex-wrap'>
              <div className='auth-left d-lg-block d-none'>
                <div className='d-flex align-items-center flex-column h-100 justify-content-center'>
                  <img src='assets/images/auth/loginHome.jpg' alt='' />
                </div>
              </div>
              <div className='auth-right py-32 px-24 d-flex flex-column justify-content-center'>
                <div className='max-w-464-px mx-auto w-100'>
                  <div>
                    <Link to='/' className='mb-40 max-w-290-px'>
                      <img src='assets/images/ORBIT2.png' alt='' />
                    </Link>
                    <h4 className='mb-12'>Sign In to your Account</h4>
                    <p className='mb-32 text-secondary-light text-lg'>
                      Welcome back! please enter your detail
                    </p>
                  </div>
                  <form action='#' onSubmit={handleSubmit}>
                    <div className='icon-field mb-16'>
                      <span className='icon top-50 translate-middle-y'>
                        <Icon icon='mage:email' />
                      </span>
                      <input
                        type='email'
                        className='form-control h-56-px bg-neutral-50 radius-12'
                        placeholder='Email'
                        value={email}
                        onChange={handleEmailChange}
                        onPaste={handleEmailPaste}
                        autoCapitalize="none"
                        autoCorrect="off"
                        spellCheck={false}
                      />
                    </div>
                    <div className='position-relative mb-20'>
                      <div className='icon-field'>
                        <span className='icon top-50 translate-middle-y'>
                          <Icon icon='solar:lock-password-outline' />
                        </span>
                        <input
                          type={showPassword ? 'text' : 'password'}
                          className='form-control h-56-px bg-neutral-50 radius-12'
                          id='your-password'
                          placeholder='Password'
                          value={password}
                          onChange={(event) => setPassword(event.target.value)}
                        />
                      </div>
                      <span
                        className={`toggle-password ${showPassword ? "ri-eye-line" : "ri-eye-off-line"} cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                        data-toggle='#your-password'
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    </div>
                    {/* <div className=''>
                      <div className='d-flex justify-content-between gap-2'>
                        <div className='form-check style-check d-flex align-items-center'>
                          <input
                            className='form-check-input border border-neutral-300'
                            type='checkbox'
                            defaultValue=''
                            id='remember'
                          />
                          <label className='form-check-label' htmlFor='remember'>
                            Remember me{" "}
                          </label>
                        </div>
                        <Link to='#' className='text-primary-600 fw-medium'>
                          Forgot Password?
                        </Link>
                      </div>
                    </div> */}
                    {error && (
                      <div className='alert alert-danger'>{error}</div>
                    )}
                    
                    {isLoading ? (
                            <div className="d-flex justify-content-center">
                                <LottieLoading text="Logged in..." />
                            </div>
                        ) : (
                            <button
                                type='submit'
                                className='btn btn-dark text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32'
                            >
                                Sign In
                            </button>
                        )}
                    <div className='mt-32 text-center text-sm'>
                      <p className='mb-0'>
                        Don’t have an account?{" "}
                        <Link to='/register' className='text-primary-600 fw-semibold'>
                          Sign Up
                        </Link>
                      </p>
                    </div>
                  </form>

                  {/* <OtpModal
                      show={showOtpModal}
                      onClose={() => setShowOtpModal(false)}
                      onSuccess={() => {
                        console.log('masuk dashboard after otp');
                        setShowOtpModal(false);
                        navigate('/dashboard');
                      }}
                      apiMessage={apiMessage}
                    /> */}
                </div>
                {modal}
              </div>
        </section>
    );
};

export default LoginPage;